// 公開するときに、作者が決める2つの許可（このピース単位）。
// 保護者設定（みまもりせってい）とは別で、ピースごとに切りかえる。

import I18n from "common/i18n";
import { usePlaySound } from "common/utils";

const Row = ({
  icon,
  label,
  value,
  onToggle,
}: {
  icon: string;
  label: string;
  value: boolean;
  onToggle: () => void;
}) => (
  <div className="flex-row-el items-center w-full gap-3 p-3 box-border rounded-xl bg-gray-10">
    <span className="flex-col-el flex-center shrink-0 material-symbols-outlined type-title text-gray-100">
      {icon}
    </span>
    <p className="type-text-left type-body text-textcolor-black flex-1 min-w-0">{label}</p>
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      className={`type-inherit-font relative shrink-0 w-12 h-[26px] rounded-full border-none cursor-pointer transition-colors ${
        value ? "bg-green-100" : "bg-gray2-100"
      }`}
    >
      <div
        className={`absolute top-0.5 left-0 w-[22px] h-[22px] bg-white rounded-full shadow transition-transform ${
          value ? "translate-x-[24px]" : "translate-x-0.5"
        }`}
      />
    </button>
  </div>
);

export const PiecePublishOptions = ({
  copyable,
  commentable,
  onChange,
}: {
  copyable: boolean;
  commentable: boolean;
  onChange: (next: { copyable: boolean; commentable: boolean }) => void;
}) => {
  const play = usePlaySound();
  const toggle = (key: "copyable" | "commentable") => () => {
    play();
    const next = { copyable, commentable };
    next[key] = !next[key];
    onChange(next);
  };

  return (
    <div className="flex-col-el items-stretch w-full gap-2">
      <Row
        icon="content_copy"
        label={I18n.t("MSG_BUILDER_PUBLISH_OPTION_COPY")}
        value={copyable}
        onToggle={toggle("copyable")}
      />
      <Row
        icon="chat_bubble"
        label={I18n.t("MSG_BUILDER_PUBLISH_OPTION_COMMENT")}
        value={commentable}
        onToggle={toggle("commentable")}
      />
    </div>
  );
};
